import { render, staticRenderFns } from "./TwoFactorChallenge.vue?vue&type=template&id=60eb9181&scoped=true&"
import script from "./TwoFactorChallenge.vue?vue&type=script&lang=js&"
export * from "./TwoFactorChallenge.vue?vue&type=script&lang=js&"
import style0 from "./TwoFactorChallenge.vue?vue&type=style&index=0&id=60eb9181&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60eb9181",
  null
  
)

export default component.exports